// extracted by mini-css-extract-plugin
export default {"message_head":"Table_message_head__YLGFL","tabla_body":"Table_tabla_body__2nMxW"};